import type { VehicleType } from '@sravni/cosago-react-library/lib/types';

export const VEHICLE_TEXT_MAP_GENITIVE_CASE_SHORT: Record<VehicleType, string> = {
  car: 'авто',
  motorcycle: 'мотоцикла',
  taxi: 'такси',
};

export const VEHICLE_TEXT_MAP_GENITIVE_CASE: Record<VehicleType, string> = {
  car: 'автомобиля',
  motorcycle: 'мотоцикла',
  taxi: 'такси',
};

export const VEHICLE_TEXT_MAP_CREATIVE_CASE: Record<VehicleType, string> = {
  car: 'автомобилем',
  motorcycle: 'мотоциклом',
  taxi: 'такси',
};

export const VEHICLE_TEXT_MAP_NOMINATIVE_CASE: Record<VehicleType, string> = {
  car: 'автомобиль',
  motorcycle: 'мотоцикл',
  taxi: 'такси',
};

export const VEHICLE_SHORT_TEXT_MAP_NOMINATIVE_CASE: Record<VehicleType, string> = {
  car: 'авто',
  motorcycle: 'мотоцикл',
  taxi: 'такси',
};
